module.exports = __webpack_public_path__ + "static/media/Pista_CabeloLoiro.c5cb108c.png";